import Closed from '../../components/Icons/images/status/28_closed_dark.svg'
import Open from '../../components/Icons/images/status/28_standard_dark.svg'
import Inactive from '../../components/Icons/images/status/28_standard_grey.svg'

export const GET_PROJECT_TASKS = 'app/TaskList/GET_PROJECT_TASKS'
export const CLEAR_PROJECT_TASKS = 'app/TaskList/CLEAR_PROJECT_TASKS'
export const GET_PROJECT_TASKS_DONE = 'app/TaskList/GET_PROJECT_TASKS_DONE'
export const GET_PROJECT_TASKS_ERROR = 'app/TaskList/GET_PROJECT_TASKS_ERROR'

export const GET_ALL_PROJECT_TASKS = 'app/PlanViewerNew/GET_ALL_PROJECT_TASKS'
export const GET_ALL_PROJECT_TASKS_DONE =
  'app/PlanViewerNew/GET_ALL_PROJECT_TASKS_DONE'
export const GET_ALL_PROJECT_TASKS_ERROR =
  'app/PlanViewerNew/GET_ALL_PROJECT_TASKS_ERROR'

// update task batch
export const UPDATE_TASKS_BATCH = 'app/TaskList/UPDATE_TASKS_BATCH'
export const UPDATE_TASKS_BATCH_DONE = 'app/TaskList/UPDATE_TASKS_BATCH_DONE'
export const UPDATE_TASKS_BATCH_ERROR = 'app/TaskList/UPDATE_TASKS_BATCH_ERROR'
export const CREATE_TASK_WITH_PINS = 'app/TaskList/CREATE_TASK_WITH_PINS'
export const CREATE_TASK_WITH_PINS_DONE =
  'app/TaskList/CREATE_TASK_WITH_PINS_DONE'
export const CREATE_TASK_WITH_PINS_ERROR =
  'app/TaskList/CREATE_TASK_WITH_PINS_ERROR'
export const CREATE_TASK_WITH_PINS_CLEAR_ERROR =
  'app/TaskList/CREATE_TASK_WITH_PINS_CLEAR_ERROR'

// update tasks in bulk
export const UPDATE_BULK_TASKS = 'app/TaskList/UPDATE_BULK_TASKS'
export const UPDATE_BULK_TASKS_DONE = 'app/TaskList/UPDATE_BULK_TASKS_DONE'
export const UPDATE_BULK_TASKS_ERROR = 'app/TaskList/UPDATE_BULK_TASKS_ERROR'

export const taskStatus = {
  DRAFT: 'Draft',
  OPEN: 'Open',
  REJECTED: 'Rejected',
  OVERDUE: 'Overdue',
  DONE: 'Done',
  CLOSED: 'Closed',
  INACTIVE: 'Inactive'
}

const taskTimeUnits = {
  MINUTES: 5,
  HOURS: 4,
  DAYS: 3,
  WEEKS: 2,
  MONTHS: 1,
  YEARS: 0
}

export const REPETITION = Array(999)
  .fill(0)
  .map((e, index) => ({ value: index + 1, label: index + 1 }))

export const REPETITION_UNIT = (formatMessage, repetition) => [
  {
    value: taskTimeUnits.DAYS,
    label:
      repetition && repetition.value === 1
        ? formatMessage({ id: 'day' })
        : formatMessage({ id: 'days' })
  },
  {
    value: taskTimeUnits.WEEKS,
    label:
      repetition && repetition.value === 1
        ? formatMessage({ id: 'week' })
        : formatMessage({ id: 'weeks' })
  },
  {
    value: taskTimeUnits.MONTHS,
    label:
      repetition && repetition.value === 1
        ? formatMessage({ id: 'month' })
        : formatMessage({ id: 'months' })
  },
  {
    value: taskTimeUnits.YEARS,
    label:
      repetition && repetition.value === 1
        ? formatMessage({ id: 'year' })
        : formatMessage({ id: 'years' })
  }
]

export const REMINDER_UNIT = (formatMessage, reminder) => [
  {
    value: 'Days',
    label:
      reminder && reminder.value === 1
        ? formatMessage({ id: 'day' })
        : formatMessage({ id: 'days' })
  },
  {
    value: 'Weeks',
    label:
      reminder && reminder.value === 1
        ? formatMessage({ id: 'week' })
        : formatMessage({ id: 'weeks' })
  },
  {
    value: 'Months',
    label:
      reminder && reminder.value === 1
        ? formatMessage({ id: 'month' })
        : formatMessage({ id: 'months' })
  },
  {
    value: 'Years',
    label:
      reminder && reminder.value === 1
        ? formatMessage({ id: 'year' })
        : formatMessage({ id: 'years' })
  }
]

export const REPEAT = (formatMessage) => [
  {
    value: null,
    label: formatMessage({ id: 'pinTask_repeatNever' })
  },
  {
    value: JSON.stringify({ quantity: 1, unit: taskTimeUnits.WEEKS }),
    label: formatMessage(
      { id: 'pinTask_repeatEveryUnit' },
      { unit: formatMessage({ id: 'week' }) }
    )
  },
  {
    value: JSON.stringify({ quantity: 2, unit: taskTimeUnits.WEEKS }),
    label: formatMessage(
      { id: 'pinTask_repeatEveryMultiple' },
      { unit: formatMessage({ id: 'weeks' }), number: 2 }
    )
  },
  {
    value: JSON.stringify({ quantity: 1, unit: taskTimeUnits.MONTHS }),
    label: formatMessage(
      { id: 'pinTask_repeatEveryUnit1es' },
      { unit: formatMessage({ id: 'month' }) }
    )
  },
  {
    value: JSON.stringify({ quantity: 3, unit: taskTimeUnits.MONTHS }),
    label: formatMessage(
      { id: 'pinTask_repeatEveryMultiple' },
      { unit: formatMessage({ id: 'months' }), number: 3 }
    )
  },
  {
    value: JSON.stringify({ quantity: 1, unit: taskTimeUnits.YEARS }),
    label: formatMessage(
      { id: 'pinTask_repeatEveryUnit1es' },
      { unit: formatMessage({ id: 'year' }) }
    )
  }
]

// Stringify the values because react-select doesnt handle select for objects properly
export const REMINDER = (formatMessage) => [
  {
    value: null,
    label: formatMessage({ id: 'pinTask_repeatNever' })
  },
  {
    value: JSON.stringify({ quantity: 3, unit: 'Hours' }),
    label: formatMessage(
      { id: 'pinTask_repeatBeforeMultiple' },
      { unit: formatMessage({ id: 'hours' }), number: 3 }
    )
  },
  {
    value: JSON.stringify({ quantity: 6, unit: 'Hours' }),
    label: formatMessage(
      { id: 'pinTask_repeatBeforeMultiple' },
      { unit: formatMessage({ id: 'hours' }), number: 6 }
    )
  },
  {
    value: JSON.stringify({ quantity: 1, unit: 'Days' }),
    label: formatMessage(
      { id: 'pinTask_repeatBeforeUnit' },
      { unit: formatMessage({ id: 'day' }), number: 1 }
    )
  },
  {
    value: JSON.stringify({ quantity: 3, unit: 'Days' }),
    label: formatMessage(
      { id: 'pinTask_repeatBeforeMultiple' },
      { unit: formatMessage({ id: 'days' }), number: 3 }
    )
  },
  {
    value: JSON.stringify({ quantity: 1, unit: 'Weeks' }),
    label: formatMessage(
      { id: 'pinTask_repeatBeforeUnit' },
      { unit: formatMessage({ id: 'week' }), number: 1 }
    )
  },
  {
    value: 'Custom',
    label: formatMessage({ id: 'pinTask_repeatCustom' })
  }
]

export const STATUS_OPTIONS = (formatMessage) => [
  {
    value: 'Open',
    label: formatMessage({ id: 'open' }),
    icon: Open
  },
  {
    value: 'Closed',
    label: formatMessage({ id: 'closed' }),
    icon: Closed
  },
  {
    value: 'Inactive',
    label: formatMessage({ id: 'inactive' }),
    icon: Inactive
  }
]

export const QUICK_FILTER_QUERY = (formatMessage, projectId) => ({
  All: {
    formatString: formatMessage({ id: 'reports_useAllPins' }),
    quickFilter: {
      projectId,
      entity: 'Pins',
      predicates: [
        {
          attribute: 'AllPins'
        }
      ]
    }
  },
  Active: {
    formatString: formatMessage({ id: 'reports_useAllActivePins' }),
    quickFilter: {
      projectId,
      entity: 'Pins',
      conjunction: 'All',
      predicates: [
        {
          attribute: 'PinStatus',
          operator: 'Is',
          values: ['Open', 'Closed']
        }
      ]
    }
  },
  Inactive: {
    formatString: formatMessage({ id: 'reports_useAllInactivePins' }),
    quickFilter: {
      projectId,
      entity: 'Pins',
      conjunction: 'All',
      predicates: [
        {
          attribute: 'PinStatus',
          operator: 'Is',
          values: ['Inactive']
        }
      ]
    }
  }
})
